import React, { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const SelectUserStatus = ({ control, required = true, isClearable = true }) => {

    const titleOptions = useMemo(() => {
        return [
            { value: 'Active', label: 'ใช้งานปกติ' },
            { value: 'Inactive', label: 'ระงับการใช้งาน' },
        ]
    }, [])

    return (
        <Controller
            name="status"
            control={control}
            rules={{ required: required }}
            render={({ field }) => <Select options={titleOptions} placeholder="เลือก" {...field} isClearable={isClearable} />}
        />
    )
}

export default SelectUserStatus
